import horizontalLoop from './horizontalLoop';

export default function () {
  const offerBanner = document.querySelector('.js-offer-banner');
  const repeatingSection = document.querySelector('.js-repeating-section');
  const repeatingLines = document.querySelectorAll('.js-repeating');
  const repeatingLine = document.querySelector('.js-single-repeating');
  /// section offer banner 3 lines repeat

  if (repeatingLines.length >= 4) {
    const getRepeaterSpan1 = offerBanner
      ? repeatingLines[1].querySelectorAll('span')
      : '';
    const getRepeaterSpan2 = offerBanner
      ? repeatingLines[2].querySelectorAll('span')
      : '';
    const getRepeaterSpan3 = offerBanner
      ? repeatingLines[3].querySelectorAll('span')
      : '';
    const getRepeaterSpan4 = offerBanner
      ? repeatingLines[0].querySelectorAll('span')
      : '';

    const repeater4 = offerBanner
      ? horizontalLoop(getRepeaterSpan4, {
          repeat: -1,
          reversed: true,
          speed: 0.3,
        })
      : '';

    const repeater1 = offerBanner
      ? horizontalLoop(getRepeaterSpan1, {
          repeat: -1,
          reversed: true,
          speed: 0.3,
        })
      : '';
    const repeater2 = offerBanner
      ? horizontalLoop(getRepeaterSpan2, { repeat: -1, speed: 0.5 })
      : '';
    const repeater3 = offerBanner
      ? horizontalLoop(getRepeaterSpan3, {
          repeat: -1,
          reversed: true,
          speed: 0.4,
        })
      : '';
  } else {
    const getRepeaterSpan1 = offerBanner
      ? repeatingLines[0].querySelectorAll('span')
      : '';
    const getRepeaterSpan2 = offerBanner
      ? repeatingLines[1].querySelectorAll('span')
      : '';
    const getRepeaterSpan3 = offerBanner
      ? repeatingLines[2].querySelectorAll('span')
      : '';

    const repeater1 = offerBanner
      ? horizontalLoop(getRepeaterSpan1, {
          repeat: -1,
          reversed: true,
          speed: 0.3,
        })
      : '';
    const repeater2 = offerBanner
      ? horizontalLoop(getRepeaterSpan2, { repeat: -1, speed: 0.5 })
      : '';
    const repeater3 = offerBanner
      ? horizontalLoop(getRepeaterSpan3, {
          repeat: -1,
          reversed: true,
          speed: 0.4,
        })
      : '';
  }
  /// END section offer banner 3 lines repeat

  /// Repeater line
  const getRepeaterSpan = repeatingSection
    ? repeatingLine.querySelectorAll('span')
    : '';
  const repeater = repeatingSection
    ? horizontalLoop(getRepeaterSpan, {
        repeat: -1,
        reversed: false,
        speed: 0.5,
      })
    : '';
  //END Repeater line
}
